import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { SharedService } from '../../_service/shared.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { MiscService } from '../../_service/misc.service';

@Component({
  selector: 'app-specialties',
  templateUrl: './specialties.component.html',
  styleUrls: ['./specialties.component.css']
})
export class SpecialtiesComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;

  perpage: number = 25; SpecialtiesList: any = []; length: number = 0; pageEvent: PageEvent; loading: boolean = true; myrole: string; pageSizeOptions = [10, 25, 50, 100, 200]; pageIndex: number = 0; loaded: boolean = false; search: string; currentUserId: any; sc3Url = ''

  constructor(private sharedapi: SharedService, public miscapi: MiscService) { }

  ngOnInit(): void {
    this.sharedapi.getRole().subscribe((item: string) => { this.myrole = item; });
    this.myrole = localStorage.getItem('role');
    this.currentUserId = localStorage.getItem('loginuserId');
    this.sc3Url = localStorage.getItem('s3url');
  }

  ngAfterViewInit() {
    this.loadSpecialtiesList(0, this.perpage);
  }

  async loadSpecialtiesList(pageIndex, perpage) {
    this.SpecialtiesList = [];
    this.paginator.pageIndex = pageIndex;
    let qString = 'search=' + this.search;
    this.loading = true; this.loaded = false;
    await this.miscapi.getSpecialtiesList(this.paginator.pageIndex, perpage, qString).subscribe((data: any) => {
      this.length = parseInt(data.totaldata);
      this.loading = false;
      this.loaded = true;
      if (data.status) {
        this.SpecialtiesList = data.data;
      } else {
        this.SpecialtiesList = [];
      }
    }, error => {
      this.loading = false;
      this.loaded = true;
      this.sharedapi.checkError(error);
    });
  }

  pageChange(event) {
    this.pageIndex = event.pageIndex;
    this.loadSpecialtiesList(event.pageIndex, event.pageSize);
  }

  public getServerData(event: PageEvent): any {
    this.perpage = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.loadSpecialtiesList(event.pageIndex, event.pageSize);
  }

}
